<template>
<v-card class="table-card table-container" elevation="8">
			<v-card-title>CO2 Emission Breakdown</v-card-title>
			<v-card-text>
				<v-data-table
					:headers="headers"
					:items="formattedTableData"
					item-value="category"
					:items-per-page="75"
					hide-default-footer
					dense
				>
				<template v-slot:item="{ item }">
					<tr :class="getRowClass(item)">
					<td v-for="(header, index) in headers" :key="`${header.value}-${index}`">
						<strong v-if="item.isTotal">{{ item[header.value] }}</strong>
						<span v-else>{{ item[header.value] }}</span>
					</td>
					</tr>
				</template>
				</v-data-table>
			</v-card-text>
		</v-card>
</template>

<script>
export default {
	props: {
		headers: Array,
		formattedTableData: Array,
	},
	methods: {
		getRowClass(item) {
			if (item.isTotal) return "total-row-border"
			if (item.isTotal1) return "total-row-1"
			if (item.isTotal2) return "total-row-2"
			if (item.isTotal3) return "total-row-3"
			if (item.isTotal4) return "total-row-3"
			if (item.isTotal5) return "total-row-5()"
			if (item.isTotal6) return "total-row-6"
			if (item.isTotal7) return "total-row-7"

			return ""
		},
	},
}
</script>

<style scoped>
.table-container {
	max-width: 100%;
	margin: 0 auto;
}
.total-row-border {
	background-color: #dbd8d8;
	border-bottom: 3px solid black !important;
}
.total-row-1 {
    color: white;
    background-color: #e9891b;
}
.total-row-2 {
    color: white;
    background-color: #cd1c42;
}
.total-row-3 {
    color: white;
    background-color: #1e9a74;
}
.total-row-5 {
    color: white;
    background-color: #6772bc;
}
.total-row-6 {
    color: white;
    background-color: #7b1fa2;
}

</style>